import type React from 'react';

import { cn } from 'utils/cn';
import LoadingIcon from '../LoadingIcon';
import PolyLoader from '../PolyLoader';
import Text from '../Text';

export interface LoaderProps {
  spinner?: boolean;
  logo?: boolean;
  fullScreen?: boolean;
  inProjectPage?: boolean;
  spinnerText?: string;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  spinner = false,
  logo = false,
  fullScreen = false,
  inProjectPage = true,
  spinnerText = 'Loading',
  className,
}) => (
  <div
    aria-label="Loading content"
    data-test-id="loader"
    role="status"
    className={cn(
      spinner && [
        'flex flex-col gap-sm2 items-center justify-center',
        '[&_svg]:origin-top [&_svg]:scale-[2] [&_svg]:text-icon-brand',
        '[&_svg>g]:![transform-origin:50%_50%] [&_svg>g]:![transform-box:view-box]',
      ],
      logo && [
        'flex flex-col gap-sm1 items-center justify-center',
        '[&_svg]:-translate-x-[2px] [&_svg]:w-md2 [&_svg]:h-md2',
      ],
      fullScreen && inProjectPage && 'w-full h-[70vh]',
      fullScreen && !inProjectPage && 'w-full h-screen',
      className,
    )}
  >
    {(logo || spinner) && <>{logo ? <PolyLoader /> : <LoadingIcon />}</>}
    <div>
      <Text color="textSecondary" variant="bodySemibold">
        {spinnerText}
      </Text>
    </div>
  </div>
);
